import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ServicePublicStrip from "@/components/layout/ServicePublicStrip";
import ChatWidget from "@/components/ChatWidget";

import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import Industrie from "@/pages/Industrie";
import Tertiaire from "@/pages/Tertiaire";
import Residentiel from "@/pages/Residentiel";
import Financement from "@/pages/Financement";
import Realisations from "@/pages/Realisations";
import APropos from "@/pages/APropos";
import Eligibility from "@/pages/Eligibility";
import Expertises from "@/pages/Expertises";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import SolutionLanding from "@/pages/SolutionLanding";
import Particuliers from "@/pages/Particuliers";
import SimulateurPac from "@/pages/SimulateurPac";
import SimulateurIA from "@/pages/SimulateurIA";
import Confidentialite from "@/pages/Confidentialite";
import Certifications from "@/pages/Certifications";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function Shell() {
  const isAdmin = window.location.pathname.startsWith("/admin");
  return (
    <>
      <ScrollToTop />
      {!isAdmin && <ServicePublicStrip />}
      {!isAdmin && <Header />}
      <main>
        <Routes>
          <Route path="/admin" element={<Admin />} />
          <Route path="/" element={<Home />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/industrie" element={<Industrie />} />
          <Route path="/industry" element={<Industrie />} />
          <Route path="/tertiaire" element={<Tertiaire />} />
          <Route path="/commercial" element={<Tertiaire />} />
          <Route path="/residentiel" element={<Residentiel />} />
          <Route path="/residential" element={<Residentiel />} />
          <Route path="/particuliers" element={<Particuliers />} />
          <Route path="/aides-pac" element={<Particuliers />} />
          <Route path="/simulateur-pac" element={<SimulateurPac />} />
          <Route path="/verifier-aides-pac" element={<SimulateurPac />} />
          <Route path="/simulateur-ia" element={<SimulateurIA />} />
          <Route path="/simulateur" element={<SimulateurIA />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/certifications" element={<Certifications />} />
          <Route path="/financement-cee" element={<Financement />} />
          <Route path="/realisations" element={<Realisations />} />
          <Route path="/expertises" element={<Expertises />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/eligibilite" element={<Eligibility />} />
          <Route path="/eligibility" element={<Eligibility />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogArticle />} />
          <Route path="/solutions/:slug" element={<SolutionLanding />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <ChatWidget />}
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
        <Toaster position="bottom-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}
